const Nails = () => {
  return (
    <div>
      <h1>Műköröm Szolgáltatások</h1>
      <p>
        Kényelméhez hozzájárulok tartós, trendhez hű és személyiségéhez illő
        műkörmökkel, valamint körmei díszítésével és ápolásával. Négy, akár hét
        hétig is tartó, strapabíró körmöket építek, melyeket igény szerint
        töltéskor akár más dizájnra vagy fazonra is változtathatunk.
      </p>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>Szolgáltatások</u>
        </h3>
        <span>Zselés műköröm töltés - 13000 Ft</span>
        <br></br>
        <span>Zselés műköröm újraépítése - 16000 Ft</span>
        <br></br>
        <span>Porcelán műköröm építés - 12000 Ft</span>
        <br></br>
        <span>Porcelán műköröm töltés - 10000 Ft</span>
        <br></br>
        <span>Porcelán műköröm újraépítése - 13000 Ft</span>
        <br></br>

        <span>Műköröm építés/töltés 'S' méret - 11000 Ft</span>
        <br></br>

        <span>Műköröm építés/töltés 'M' méret - 12000 Ft</span>
        <br></br>
        <span>Műköröm építés/töltés 'L' méret - 15000 Ft</span>
        <br></br>

        <span>Műköröm építés egyszinű - 14000 Ft</span>
        <br></br>
        <span>Műköröm építés prémium + gél lakk - 18000 Ft</span>
        <br></br>
        <span>Műköröm építés XL - 20000 Ft</span>
        <br></br>
        <span>Műköröm építés - extrém forma - 24000 Ft</span>
        <br></br>
        <span>Műköröm újraépítés egyszínű - 22000 Ft</span>
        <br></br>
        <span>Műköröm újtaépítés prémium + gél lakk - 23000 Ft</span>
        <br></br>
        <span>Műköröm újraépítés XL - 29800 Ft</span>
        <br></br>
        <span>Műköröm újraépítés - extrém forma - 32400 Ft</span>
        <br></br>
        <span>Műköröm töltés egyszínű - 14000 Ft</span>
        <br></br>
        <span>Műköröm töltés prémium + géllakk - 18000 Ft</span>
        <br></br>
        <span>Műköröm töltés XL - 19000 Ft</span>
        <br></br>
        <span>Pótlás más szolgáltatás mellé - 2500 Ft/db</span>
        <br></br>
        <span>
          Műköröm / Géllakk eltávolítása más szolgáltatás előtt - 2000 Ft
        </span>
        <br></br>
        <span>Műköröm végleges eltávolítása - 5000 Ft</span>
        <br></br>
        <span>
          <u>Speciális ajánlatok</u>
        </span>
        <br></br>
        <span>Francia gél lakk + 20%</span>
        <br></br>
        <span>Műköröm eltávolítás + manikűr - 5000 Ft</span>
        <br></br>
        <p>
          Reméljük, hogy ezek a műköröm szolgáltatások segítenek megtalálni a
          tökéletes stílust és gondoskodnak körmeid szépségéről és egészségéről!
        </p>
        <br></br>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>Díszítések</u>
        </h3>
        <span>Swarovski formakő - 600 Ft/db</span>
        <br></br>
        <span>Swarovski starssz - 100 Ft/db</span>
        <br></br>
        <span>Swarovski Pixie kisebb díszítés - 700 Ft/db</span>
        <br></br>
        <span>Swarovski Pixie teljes körömre (normál hossz) - 2000 Ft/db</span>
        <br></br>
        <span>Swarovski Pixie teljes körömre (XL) - 2800 Ft/db</span>
        <br></br>
        <span>Plusz díszítés - 400 Ft/db</span>
        <br></br>
        <span>Extra díszítés - 1000 - 1500 Ft/db</span>
        <br></br>
        <span>Porcekán virág - 500 Ft/db</span>
        <br></br>
      </div>
      <br></br> <br></br>
    </div>
  );
};

export default Nails;
